/**
 * @ngdoc service
 * @name app.closingsAndDelaysService
 * @description
 * # closingsAndDelaysService
 * Service to talk with backend api.
 * @requires app.apiService
 * @requires constants:config
 **/

/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * closingsAndDelaysService
 \*---------------------------------------------------------*/
/* @ngInject */
function closingsAndDelaysService(apiService, config, $q) {
  /**
   * @ngdoc
   * @name app.closingsAndDelaysService#getClosings
   * @methodOf app.closingsAndDelaysService
   * @example
   * ``` js
   * closingsAndDelaysService.getClosings('CT', 'Hartford');
   * ```
   * @param {string} regionCode passes the id for current poll.
   * @param {string} city passes the current selection.
   * @description
   * Service method to talk with backend api. It calls the apiService.wrap function,
   * passing the string formed from relative base Url, the '/schools/closing/' string,
   * the regionCode, and city string.
   * @returns {httpPromise} Promise that will resolve with the closings and delays object.
   **/
  this.getClosings = (regionCode, city) => {
    return apiService.wrap(config.relBaseUrlAPi + '/schools/closing/' + regionCode + '/' + city, {}, 'regions');
  };

  /**
   * @ngdoc
   * @name app.closingsAndDelaysService#hasClosings
   * @methodOf app.closingsAndDelaysService
   * @example
   * ``` js
   * closingsAndDelaysService.getClosings('LI');
   * ```
   * @param {string} regionCode passes the id for current poll.
   * @description
   * Service method to talk with backend api. It calls the apiService.wrap function, passing
   * the string formed from relative base Url, the '/schools/closing/' string, the regionCode,
   * and '/all' string.
   * @returns {httpPromise} Promise that will resolve a boolean to check if the passed in region has cosings.
   **/
  this.hasClosings = (regionCode) => {
    const defer = $q.defer();

    apiService.wrap(config.relBaseUrlAPi + '/schools/closing/' + regionCode + '/All', {}, 'regions').then((data) => {
      try {
        if (data.data.DataSet.NewDataSet.closings && data.data.DataSet.NewDataSet.closings.length > 0) {
          defer.resolve(true);
          return;
        }
      } catch (err) {
        console.error('Closings & Delays does not have any closings ' + err);
      }

      defer.resolve(false);
    }).catch(defer.reject);

    return defer.promise;
  };
}

closingsAndDelaysService.$inject = [
  'apiService',
  'config',
  '$q'
];

const api = angular
  .module('closingsAndDelaysService', [])
  .service('closingsAndDelaysService', closingsAndDelaysService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/closingsAndDelays.js
 **/